import React from "react";
import s from "./Header.module.scss";
import {
  CaretDownFilled,
  GlobalOutlined,
  LogoutOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Dropdown, Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/AuthSlice";
import { AppDispatch, persistor, RootState } from "../../redux/store";
import {
  getPartnerBalance,
  getTransactionsHistory,
  resetBilling,
} from "../../redux/BillingSlice";
import {
  getAdminUsersList,
  getDeclarantsWithApplications,
  getManagerEmployeesList,
  getManagerWithBrokers,
  getUsersList,
  resetUser,
} from "../../redux/UserSlice";
import {
  getApplicationsList,
  resetApplication,
  setLang,
} from "../../redux/ApplicationSlice";
import i18n from "../../i18n";
import { useTranslation } from "react-i18next";
import { getServicesList } from "../../redux/ServiceSlice";

type Props = {};

const Header = (props: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user.user);
  const lang = useSelector((state: RootState) => state.application.lang);
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    dispatch(logout());
    dispatch(resetApplication());
    dispatch(resetUser());
    dispatch(resetBilling());

    await persistor.purge();
    navigate("/login");
  };

  const options5 = (
    <Menu>
      {
        <Menu.Item key="1">
          <Link to="/myAccount">
            <div>
              <UserOutlined className={s.icon} />
              {t("Личный кабинет")}
            </div>
          </Link>
        </Menu.Item>
      }
      <Menu.Item key="2">
        <div onClick={() => handleLogout()}>
          <LogoutOutlined className={s.icon} />
          {t("Выйти из системы")}
        </div>
      </Menu.Item>
    </Menu>
  );

  const options4 = (
    <Menu>
      <Menu.Item key="2">
        <div
          onClick={() => {
            dispatch(setLang("en"));
            changeLang("en");
          }}
          className={s.menu_lang_item}
        >
          <img src="/united-states.png" className={s.flag} />
          EN
        </div>
      </Menu.Item>
      <Menu.Item key="3">
        <div
          onClick={() => {
            dispatch(setLang("ru"));
            changeLang("ru");
          }}
          className={s.menu_lang_item}
        >
          <img src="/russia (1).png" className={s.flag} />
          RU
        </div>
      </Menu.Item>
    </Menu>
  );

  const changeLang = (lang: "en" | "ru") => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className={s.header}>
      <div className={s.logo_block}>
        <Link
          style={{ display: "block", width: "55px" }}
          to={
            user?.role === "broker"
              ? "/brokersApplications"
              : user?.role === "admin"
                ? "/admin/applications"
                : "/managerApplications"
          }
        >
          <img src="/Logo MCTAC.png" className={s.logo} />
        </Link>
        <Link
          to={
            user?.role === "broker"
              ? "/brokersApplications"
              : user?.role === "admin"
                ? "/admin/applications"
                : "/managerApplications"
          }
          className={s.hub}
        >
          Digital Transit Hub
        </Link>
      </div>
      <div>
        <div>
          {user?.role === "admin" && (
            <div className={s.menu}>
              <Link to="/admin/applications" className={s.menu_item}>
                {t("Заявления")}
              </Link>
              <Link
                to="/admin/users"
                className={s.menu_item}
                onClick={() => dispatch(getManagerWithBrokers(1))}
              >
                {t("Пользователи")}
              </Link>
              <Link
                to="/queue"
                className={s.menu_item}
                onClick={() => dispatch(getDeclarantsWithApplications())}
              >
                {t("Управление очередью")}
              </Link>
              {user.role === "admin" ? (
                <div className={s.menu}>
                  <Link
                    to={"/balanceList"}
                    className={s.menu_item}
                    onClick={() => {
                      dispatch(getTransactionsHistory());
                      dispatch(getUsersList(1));
                    }}
                  >
                    {t("Баланс")}
                  </Link>
                </div>
              ) : (
                <div className={s.menu}>
                  {/* <Link to="/payment_link" className={s.menu_item}>
                    {t("Оплатить заявку")}
                  </Link> */}
                  <Link to="/home" className={s.menu_item}>
                    {t("Заявления")}
                  </Link>
                  <Link
                    to={"/balance"}
                    className={s.menu_item}
                    onClick={() => dispatch(getPartnerBalance())}
                  >
                    {t("Баланс")}
                  </Link>
                </div>
              )}
            </div>
          )}
        </div>
        <div>
          {user?.role === "driver" && (
            <div className={s.menu}>
              <Link to="/payment_link" className={s.menu_item}>
                {t("Оплатить заявку")}
              </Link>
              <Link to="/applications" className={s.menu_item}>
                {t("Заявления")}
              </Link>
            </div>
          )}
        </div>
        <div>{user?.role === "broker" && <div className={s.menu}></div>}</div>
        <div>
          {user?.role === "regional_manager" && (
            <div className={s.menu}>
              <Link
                to="/managerApplications"
                className={s.menu_item}
                onClick={() => dispatch(getApplicationsList(1))}
              >
                {t("Заказы")}
              </Link>

              <Link
                to="/employees"
                className={s.menu_item}
                onClick={() => dispatch(getManagerEmployeesList(1))}
              >
                {t("Поставщики услуг")}
              </Link>
              <Link
                to="/services"
                className={s.menu_item}
                onClick={() => {
                  dispatch(getManagerEmployeesList(1));
                  dispatch(getServicesList(1));
                }}
              >
                {t("Услуги")}
              </Link>
            </div>
          )}
        </div>
      </div>
      <div className={s.user}>
        <div className={s.img_wrapper}>
          <img src="/noImage.png" className={s.img} />
        </div>

        <Dropdown overlay={options5}>
          <ol className={s.ol}>
            <div style={{ marginRight: "10px", textAlign: "left" }}>
              {user?.full_name}
            </div>{" "}
            <CaretDownFilled />
          </ol>
        </Dropdown>
      </div>
      <div>
        <Dropdown overlay={options4}>
          <div>
            <GlobalOutlined />
            &nbsp;&nbsp;
            {lang === "en" ? "EN" : "RU"} &nbsp;
            <CaretDownFilled />
          </div>
        </Dropdown>
      </div>
    </div>
  );
};

export default Header;
